import { FC, useMemo } from "react";

interface Attribute {
    name: string;
    value: string;
}

interface MainAttributeProps {
    data: Attribute[];
}

const MainAttribute = ({ data }: any) => {
    const attributes = useMemo(() => data, [data]);

    return (
        <>
            {attributes.map((item: Attribute, index: number) => (
                <div
                    key={index}
                    className="flex h-full my-2 border-b-2 dark:border-slate-500 items-center justify-between space-x-4 text-sm"
                >
                    <div className="font-bold text-gray-600 dark:text-slate-300">{item.name}:</div>
                    <div className="text-gray-700 dark:text-slate-200 pr-6">{item.value}</div>
                </div>
            ))}
        </>
    );
};

export default MainAttribute;
